/** Convert camelCase API field names to kebab-case query keys (e.g. minStars → min-stars). */
export function camelToKebabCase(key: string): string {
  return key.replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`);
}

export function buildQueryString(
  params: Record<string, string | number | boolean | undefined | null>,
): string {
  const searchParams = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === null) continue;
    if (Array.isArray(value)) {
      if (value.length > 0) searchParams.set(key, value.join(','));
      continue;
    }
    searchParams.set(key, String(value));
  }
  const serialized = searchParams.toString();
  return serialized.length === 0 ? '' : `?${serialized}`;
}

/** Default serializer: camelCase keys → kebab-case wire keys, skip undefined/null. */
export function serializeQueryCamelToKebab(
  query: Record<string, string | number | boolean | undefined | null | readonly string[]>,
): Record<string, string | undefined> {
  const out: Record<string, string | undefined> = {};
  for (const [key, value] of Object.entries(query)) {
    if (value === undefined || value === null) continue;
    const wireKey = camelToKebabCase(key);
    if (Array.isArray(value)) {
      if (value.length > 0) out[wireKey] = value.join(',');
      continue;
    }
    if (typeof value === 'boolean') {
      out[wireKey] = value ? 'true' : 'false';
      continue;
    }
    out[wireKey] = String(value);
  }
  return out;
}
